/** User menu above the sidebar's user block (Admin-Dashboard): 224 px, radius 14; Mon profil · Paramètres · Déconnexion (red). */
import { useEffect, type RefObject } from "react";
import { Link } from "@tanstack/react-router";
import { ROLE_LABEL } from "@/contracts/permissions";
import type { StaffSession } from "@/contracts/staff-auth";

export function UserMenu({ session, anchor, onClose, onLogout, onNavigate }: { session: StaffSession; anchor: RefObject<HTMLElement | null>; onClose: () => void; onLogout: () => void; onNavigate?: () => void }) {
  useEffect(() => {
    const key = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    const click = (e: MouseEvent) => !anchor.current?.contains(e.target as Node) && onClose();
    window.addEventListener("keydown", key);
    window.addEventListener("mousedown", click);
    return () => {
      window.removeEventListener("keydown", key);
      window.removeEventListener("mousedown", click);
    };
  }, [anchor, onClose]);
  const { user } = session;
  const item = "flex h-[38px] w-full items-center rounded-[9px] px-2.5 text-[13px] font-bold text-ink-2 hover:bg-[#F4F5F9]";
  const done = () => {
    onClose();
    onNavigate?.();
  };
  return (
    <div role="menu" className="absolute bottom-[calc(100%+6px)] left-3 z-20 w-[224px] rounded-[14px] border border-line bg-white p-1.5 text-ink shadow-[0_18px_40px_-16px_rgba(27,28,49,.45)]">
      <div className="px-2.5 pb-2 pt-1.5">
        <div className="break-words text-[13px] font-extrabold">
          {user.firstName} {user.lastName}
        </div>
        <div className="text-[11.5px] text-muted">{ROLE_LABEL[user.role]}</div>
      </div>
      <Link role="menuitem" to="/parametres" onClick={done} className={item}>
        Mon profil
      </Link>
      <Link role="menuitem" to="/parametres" onClick={done} className={item}>
        Paramètres
      </Link>
      <div className="my-1 h-px bg-line" />
      <button role="menuitem" type="button" onClick={onLogout} className={`${item} text-[#B42318]`}>
        Déconnexion
      </button>
    </div>
  );
}
